import { read } from './store/note';
import { isLinkAttribution } from './types';
import { useEffect, useState } from 'react';
import { fetchAttribution } from './store/attribution';
export const useNote = (subject, store) => {
    const [note, setNote] = useState(read(subject, store));
    useEffect(() => {
        async function fetch() {
            if (isLinkAttribution(note.attributedTo)) {
                const attribution = await fetchAttribution(note.attributedTo, store);
                setNote({ ...note, attributedTo: attribution });
            }
        }
        fetch();
    }, []);
    return note;
};
//# sourceMappingURL=useNote.js.map